<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch"
                    :colSpan="4" />
                </Col>
            </Row>
        </transition>

        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">购物车管理</span>
						<span style="margin-left:20px;">会员类别:</span>
						<RadioGroup v-model="userType"
						    style="margin-left:4px;"
						    @on-change="onUserTypeChage">
						    <Radio label="F"> <span>外部会员</span></Radio>
						    <Radio label="E"> <span>内部会员</span></Radio>
						</RadioGroup>
                    </div>
                    <div class="right-bar">

                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :extHeight="60"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>

        <PreSaleOrderDetail ref="preSaleOrderDetailModal" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { dateRender, dateTimeRender } from '@/libs/tableRowTimeRender';
import PreSaleOrderDetail from './preSale-order-detail';
import { getPreSaleOrderList } from '@/api/modules/preSale-management/preSale-order';
import { numberToFixed } from '@/components/number-input/display-format';

export default {
    name: 'PreSaleOrderList',
    components: {
        StandPaginationTable,
        SearchCard,
        PreSaleOrderDetail
    },
    data() {
        return {
            userType:'F',
            btnLoading: false,
            mainTable: {
                tableColumns: [
                    { title: '会员名称', key: 'userPersonName', align: 'center' },
                    { title: '会员账号', key: 'userName', align: 'center' },
                    { title: '会员电话', key: 'userPhone', align: 'center' },
                    { title: '客户经理', key: 'userCustomerManagerName', align: 'center' },
                    { title: '商品总数量', key: 'totalCount', align: 'center',
                        render: (h, params) => h('span', parseFloat(params.row.totalCount.toFixed(2)))
                    },
                    { title: '商品总金额', key: 'totalMoney', align: 'center' },
                    { title: '定单状态', key: 'preSaleOrderRecordOrderStatus', align: 'center' },
                    { title: '周次', key: 'weekDesc', align: 'center' },
                    { title: '发货日期', key: 'preSaleOrderRecordSendProductDate', align: 'center', render: (h, params) => dateRender(h, params.row.preSaleOrderRecordSendProductDate) },
                    { title: '下单时间', key: 'preSaleOrderRecordCreateAt', align: 'center', render: (h, params) => dateTimeRender(h, params.row.preSaleOrderRecordCreateAt) },
                    {
                        title: '详情',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return "";
                            }
                            else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        on: {
                                            click: () => {
                                                this.$refs.preSaleOrderDetailModal.showModal(params.row.preSaleOrderRecordUuid);
                                            }
                                        }
                                    }, '查看')
                                ]);
                            }
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '名称或账号', type: 'Input', value: '', name: 'concat(userPersonName,userName)', sql: 'like' },
                    { label: '会员电话', type: 'Input', value: '', name: 'userPhone', sql: 'like' },
                    { label: '发货日期', type: 'Daterange', value: '', name: 'preSaleOrderRecordSendProductDate', sql: 'dateBetween' },
                    { label: '下单时间', type: 'Daterange', value: '', name: 'preSaleOrderRecordCreateAt', sql: 'dateBetween' }
                ]
            }
        };
    },
    // props: {
    //     userType: { type: String, default: '' }
    // },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getMainTableRecords();
        },
        onUserTypeChage(){
            this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'memberType',
                    type: 'eq',
                    value: this.userType
                });
            }
            getPreSaleOrderList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    let totalCount = 0;
                    let totalMoney = 0;
                    this.mainTable.tableData.forEach(e => {
                        totalCount += e.totalCount;
                        totalMoney += e.totalMoney;
                    });
                    this.mainTable.tableData.push({
                        customerManagername: '合计',
                        totalCount: totalCount,
                        totalMoney: numberToFixed(totalMoney, 2),
                        action: -1
                    });
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
